import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class TpEvaluatorTpJobPaymentSearchParams extends SearchParamsBase {
  static saveType = 'TpEvaluatorTpJobPaymentSearchParams';
  initialize() {
    this.TpClientInvoiceId = null;
    this.ThirdPartyIds = '';
    this.UseJobDateRange = false;
    this.JobDateBefore = dateTimeHelper.indefiniteDateValue();
    this.JobDateAfter = dateTimeHelper.indefiniteDateValue();
    this.Countries = [];
    this.FieldWorkOffices = [];
    this.Statuses = [];
    this.Level1 = '';
    this.Level2 = '';
    this.Level3 = '';
    this.Level4 = '';
    this.Level5 = '';
    this.AdHocGroup = '';
    // this.LocationGroup = '';
    // this.Wave = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'ThirdPartyIds',
      label: 'Third-Party IDs (id1,id2,id3...)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'UseJobDateRange',
      label: 'Job Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'JobDateBefore',
      label: 'Completed On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseJobDateRange,
    },
    {
      fieldName: 'JobDateAfter',
      label: 'Completed On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseJobDateRange,
    },
    {
      fieldName: 'Countries',
      label: 'Countries',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'FieldWorkOffices',
      label: 'Fieldwork office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'Statuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 45,
    },
    {
      fieldName: 'Level1',
      label: 'Level 1',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level2',
      label: 'Level 2',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level3',
      label: 'Level 3',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level4',
      label: 'Level 4',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Level5',
      label: 'Level 5',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'AdHocGroup',
      label: 'Ad-Hoc Invoice Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    // {
    //   fieldName: 'LocationGroup',
    //   label: 'Location Group',
    //   className: 'col-3',
    //   type: InputTypesEnum.Text,
    // },
    // {
    //   fieldName: 'Wave',
    //   label: 'Wave',
    //   className: 'col-3',
    //   type: InputTypesEnum.Text,
    // },
  ];
}
